import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Desktop = styled.div`
    flex-direction: row;
    justify-content: space-between;
    gap: ${rem(25)};
    display: flex;
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }
    @media (max-width: ${breakpoints.md}px) {
        display: block;
    }
`;

export const NoData = styled.div`
    flex-direction: row;
    justify-content: space-between;
    gap: ${rem(25)};
    display: flex;
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    margin-left: ${rem(20)};
    margin-right: ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
        margin-left: ${rem(30)};
        margin-right: ${rem(30)};
    }
    @media (max-width: ${breakpoints.md}px) {
        display: block;
    }
`;

export const Content = styled.div`
    padding: 0 ${rem(10)};
    width: 100%;
`;

export const Section = styled.div``;

export const Sidebar = styled.div<{ isHide?: boolean }>`
    width: 100%;
    background: ${({ theme }) => theme.colors.white};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    border-bottom-left-radius: ${rem(16)};
    border-bottom-right-radius: ${rem(16)};
    padding: ${rem(15)};
    margin: ${rem(0)} 0;
    display: flex;
    flex-direction: column;
    ${(prop) => (prop.isHide ? `position: relative` : `position: fixed`)};
    top: ${rem(MOBILE_HEADER_HEIGHT)};
    z-index: 9;

    @media (min-width: ${breakpoints.sm}px) {
        top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }

    @media (min-width: ${breakpoints.md}px) {
        position: sticky;
        height: fit-content;
        border: 1px solid ${({ theme }) => theme.colors.border};
        border-radius: ${rem(16)};
        min-width: ${rem(300)};
        max-width: ${rem(300)};
    }
`;

export const SidebarTitle = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    padding-bottom: ${rem(20)};
    padding-left: ${rem(5)};
`;

export const SidebarLabel = styled.div`
    padding: ${rem(5)} 0 ${rem(5)} ${rem(5)};
    margin: ${rem(3)} 0;
    cursor: pointer;

    &.active {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        border-left: ${rem(4)} solid ${({ theme }) => theme.colors.primary};
        margin-left: ${rem(4)};
    }
`;

export const SidebarMore = styled.div`
    display: block;
    cursor: pointer;

    @media (min-width: ${breakpoints.md}px) {
        display: none;
    }
`;

export const SidebarContent = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex-direction: column;
    padding-top: ${rem(20)};

    @media (max-width: ${breakpoints.md}px) {
        ${(prop) => (prop.isOpen ? `display: flex` : `display: none`)};
    }
`;

export const SidebarItem = styled.div``;

export const IconDown = styled(IconTemplate)`
    svg {
        margin-right: ${rem(10)};
        height: ${rem(12)};
        width: ${rem(16)};
    }
`;
